import { css } from '@inter-ikea-kompis/web-component';
const HEADER_HEIGHT_SMALL = 60;
const FILLER_WIDTH = 40;
export default class SheetHeaderStyle {
    /**
     * Returns styles.
     *
     * @param options Options Object.
     * @param options.theme Theme.
     * @param options.floatingHeader Floating header.
     * @param options.zIndex ...
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing, color, breakpoint } = options.theme;
        return css `
			:host {
				z-index: ${options.zIndex};
				position: ${options.floatingHeader ? 'absolute' : 'relative'};
				width: 100%;
				background-color: ${options.floatingHeader ? 'transparent' : `${color.neutral.white}`};
			}
			.headingContainer {
				display: flex;
				align-items: center;
				position: relative;
				width: 100%;
				padding: 0 ${spacing.space75 / 16}rem;
				min-height: ${spacing.space550 / 16}rem;
			}
			.header {
				flex-grow: 1;
				text-align: center;
				color: ${color.text.dark};
			}
			.filler {
				width: ${FILLER_WIDTH / 16}rem;
			}
			@media screen and (max-width: ${breakpoint.medium.width / 16}rem) {
				.headingContainer {
					min-height: ${HEADER_HEIGHT_SMALL / 16}rem;
				}
			}
			@media screen and (min-width: ${breakpoint.large.width / 16}rem) {
				.headingContainer {
					padding: 0 ${spacing.space200 / 16}rem;
				}
			}
		`;
    }
}
//# sourceMappingURL=SheetHeaderStyle.js.map